export default {
    'project'           : 'Cancer TODAY' , 
    'project_slug'      : 'today' , 
    'publicPath'        : 'today_reloaded',
    'margin'            : { top: 30, right: 200, bottom: 80, left: 100, top_page: 0, left_page: 0 , title_height : 70 } , 
    'data_version'      : 2022, // 
    'data'      : {
        '2020' : { 'label' : 'Globocan 2020' , value : 2020  },
        '2022' : { 'label' : 'Globocan 2022' , value : 2022 , 'date_release' : '08.02.2024' },
        '2022ps' : { 'label' : 'Globocan 2022 - P. States' , value : '2022ps' },
    },
    'all_years' : [2022] , 
    'year_counter' : 5 , 
    'all_cancers_id'    : 39 , 
    'exclude_cancer_sites' : [37,38] , 
    'exclude_all_cancers_id' : [39,40] ,//DXX, grouped, all   
    'all_cancers_ids_list' : [39,40] ,
    'languages' : ["en"] , 
    'languages_labels' : [
        { "iso" : "en" , "label" : "English" }
    ] ,
    'enable_bars_comparison' : true ,
    'enable_highlight' : true , 
    'nmsc_cancer' : 17 , 
    'add_iso_code_to_downloads' : true , 
    'check_availability' : false , 
    'check_static_cancer_availability' : true , 
    'predefined_population' : true , 
    'check_predefined_population' : true , // if true, then each grouping populations will be replaced by the group name in title
    'all_populations'   : [900] , 
    'hdi_populations' : [984,983,982,981] ,
    'groupings' : {}, 
    'year_base' : 2020 , 
    'color_no_data'   : '#7d7d80',
    'color_outmap'   : '#f0f0f0',
    'colors_types' : ['#0355a1','#d91616','#006d2c'], 
    'colors_sexes' : ['#3383b8','#ad027d'], 
    'colors_ages' : ["#4e79a7","#f28e2c","#e15759","#76b7b2","#59a14f","#edc949","#af7aa1","#ff9da7","#9c755f","#bab0ab","#1b9e77","#d95f02","#7570b3","#e7298a","#66a61e","#e6ab02","#a6761d","#666666"] , 
    'ages_start'        : [0,5,10,15,20,25,30,35,40,45,50,55,60,65,70,75,80,85], 
    'ages_labels' : ['0-4','5-9','10-14','15-19','20-24','25-29','30-34','35-39','40-44','45-49','50-54','55-59','60-64','65-69','70-74','75-79','80-84','85+'], 
    'indicators' : [
        {'key' : 'total' , 'label' : 'Absolute numbers' } ,
        {'key' : 'percent' , 'label' : '% of progression since 2020' } 
    ] , 
    'isos' : {
    },
    'show_pyramid' : true , 
    'print' : {
        'delay_puppetter' : 4000 ,
        'width_png' : 1480 , 
        'height_png' : 832 , 
        'width_pdf' : 1480 , 
        'height_pdf' : 860 , 
        'delay_loader' : 4500 
    } , 
    'max_filename_length' : 60 , 
    'key_title' : 'Age standardized-rate' , 
    'significant_digit' : 3 , 
    'home_graphics' : [
        { "name" : "Multi bars" , "offset" : "col-md-offset-1" ,  "active" : "active" , "icon" : "icons/svg/orange/bar.svg" } , 
        { "name" : "Pie chart" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/pie_chart.svg"  } , 
        { "name" : "Dual bars" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/dual.svg" } , 
        { "name" : "Maps" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/connection_map.svg" } , 
        { "name" : "Globe" , "offset" : undefined , "class" : " globe_icon" , "active" : "active" , "icon" : "icons/svg/orange/globe.svg"} , 
        { "name" : "Tree map" , "offset" : "col-md-offset-1" ,  "active" : "active" , "icon" : "icons/svg/orange/treemap.svg"  } , 
        { "name" : "Scatter plot" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/scatterplot.svg"  } , 
        { "name" : "Table" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/time_table.svg" } , 
        { "name" : "Sunburst" , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/sunburst.svg"  },
        { "name" : "Maps (cancer site ranking)" , "is_new" : true , "offset" : undefined , "active" : "active" , "icon" : "icons/svg/orange/connection_map.svg"} // , 
    ], 
    'enable_population_grouping' : true ,
    'prevent_sex_specific' : true , 
    'population_select_close_on_select' : true ,
    'cancer_select_close_on_select' : true ,
    'allow_both_sexes_combined' : true ,
    'populations_groupings_order' : [
        { 'key' : '' , 'pos' : 0  },
        { 'key' : 'Africa' , 'pos' : 0  },
        { 'key' : 'Asia' , 'pos' : 0  },
        { 'key' : 'Northern America' , 'pos' : 0  },
        { 'key' : 'Latin America and the Caribbean' , 'pos' : 0  },
        { 'key' : 'Europe' , 'pos' : 0  },
        { 'key' : 'Oceania' , 'pos' : 0  },
        
        { 'key' : 'Continents' , 'pos' : 0  },
        { 'key' : 'Regions' , 'pos' : 0  },
        { 'key' : 'GICR hub region' , 'pos' : 0  },
        { 'key' : 'HDI' , 'pos' : 0  },
        { 'key' : 'World Bank Classification' , 'pos' : 0  },
        { 'key' : 'WHO region' , 'pos' : 0  },

        { 'key' : 'Other' , 'pos' : 0  }
    ],
    'economics' :  [
        { country_code : 160 , total_cost : 127416 , cost_per_case : 0.02666 , direct_cost : 42132 , informal_cost : 6905 }
    ],
    'populations_groupings' : [
        {
            'label' : 'Human Development Index (HDI)' , 
            'name' : 'hdi' , 
            'field' : '##field_value_hdi##' , 
            'groups' : [
                { 'id' : 4 , 'field' : 4 ,  'label' : 'Very high HDI' , 'country' : 981 , 'color' : '#2c7bb6' , 'sort' : 1 ,'text_color' : '#fff'} , 
                { 'id' : 3 , 'field' : 3 , 'label' : 'High HDI' , 'country' : 982 , 'color' : '#abd9e9' , 'sort' : 2 } , 
                { 'id' : 2 , 'field' : 2 , 'label' : 'Medium HDI' , 'country' : 983 , 'color' : '#e66101' , 'sort' : 3,'text_color' : '#fff' } ,
                { 'id' : 1 , 'field' : 1 , 'label' : 'Low HDI', 'country' : 984  , 'color' : '#d7191c' , 'sort' : 4 ,'text_color' : '#fff'} , 
                { 'id' : 5 , 'label' : 'China', 'country' : 160 , 'color' : '#5c2d4f' } , 
                { 'id' : 6 , 'label' : 'India', 'country' : 356 , 'color' : '#d40f50' } 
            ]
        },
        {
            'name' : 'continents' ,
            'field' : 'continent_code' , 
            'groups' : [
                { 'id' : 1 ,'label' : 'Africa' , 'country' : 903 , 'color' : '#e51919' , 'text_color' : '#fff' ,  'sort' : 1 } ,  // old 
                { 'id' : 3 ,'label' : 'Northern America' , 'short_label' : 'North America', 'text_color' : '#fff' , 'country' : 905 , 'color' : '#7A263C' , 'sort' : 5} , 
                { 'id' : 2 ,'label' : 'Latin America and the Caribbean' , 'short_label' : 'South America' ,  'country' : 904 , 'color' : '#F6F31E', 'sort' : 4} , 
                { 'id' : 4 ,'label' : 'Asia' , 'country' : 935 , 'color' : '#2EAD10' , 'sort' : 2} ,
                { 'id' : 5 ,'label' : 'Europe' , 'country' : 908 , 'color' : '#196be5',  'text_color' : '#fff' , 'sort' : 3} ,
                { 'id' : 6  ,'label' : 'Oceania' , 'country' : 909 , 'color' : '#e519d1', 'sort' : 6 ,'text_color' : '#fff' }
            ]
        },
        {
            'name' : 'regions' ,
            'field' : 'area_code' , 
            'groups' : [
                { "id": 1,"label": "Eastern Africa","continent": 1,"globocan_id": 910 , 'color' : '#e51919' ,'text_color' : '#fff'},
                {"id": 2,"label": "Middle Africa","continent": 1,"globocan_id": 911 , 'color' : '#e53119' ,'text_color' : '#fff'},
                {"id": 3,"label": "Northern Africa","continent": 1,"globocan_id": 912 , 'color' : '#e54a19' ,'text_color' : '#fff'},
                {"id": 4,"label": "Southern Africa","continent": 1,"globocan_id": 913 , 'color' : '#e56219' ,'text_color' : '#fff'},
                {"id": 5,"label": "Western Africa","continent": 1,"globocan_id": 914 , 'color' : '#e57b19' ,'text_color' : '#fff'},
                {"id": 6,"label": "Caribbean","continent": 2,"globocan_id": 915 , 'color' : '#e5d119' },
                {"id": 7,"label": "Central America","continent": 2,"globocan_id": 916 , 'color' : '#e1e519' },
                {"id": 8,"label": "South America","continent": 2,"globocan_id": 931 , 'color' : '#c8e519' },
                {"id": 9,"label": "Northern America","continent": 2,"globocan_id": 905 , 'color' : '#7A263C' ,'text_color' : '#fff'},
                {"id": 10,"label": "Eastern Asia","continent": 4,"globocan_id": 906 , 'color' : '#19e51b' },
                {"id": 11,"label": "South-Eastern Asia","continent": 4,"globocan_id": 920 , 'color' : '#19e51b' },
                {"id": 12,"label": "South-Central Asia","continent": 4,"globocan_id": 921 , 'color' : '#19e56b' },
                {"id": 13,"label": "Western Asia","continent": 4,"globocan_id": 922 , 'color' : '#19e5ba' },
                {"id": 14,"label": "Eastern Europe","continent": 5,"globocan_id": 923 , 'color' : '#196be5' ,'text_color' : '#fff' },
                {"id": 15,"label": "Northern Europe","continent": 5,"globocan_id": 924 , 'color' : '#1940e5' ,'text_color' : '#fff' },
                {"id": 16,"label": "Southern Europe","continent": 5,"globocan_id": 925 , 'color' : '#1d19e5' ,'text_color' : '#fff'},
                {"id": 17,"label": "Western Europe","continent": 5,"globocan_id": 926 , 'color' : '#4819e5' ,'text_color' : '#fff'},
                {"id": 18,"label": "Australia/New Zealand","continent": 6,"globocan_id": 927 , 'color' : '#e519d1' ,'text_color' : '#fff' },
                {"id": 19,"label": "Melanesia","continent": 6,"globocan_id": 928 , 'color' : '#e519ac' ,'text_color' : '#fff' },
                {"id": 20,"label": "Micronesia","continent": 6,"globocan_id": 954 , 'color' : '#e51987' ,'text_color' : '#fff' },
                {"id": 21,"label": "Polynesia","continent": 6,"globocan_id": 957 , 'color' : '#e51962' ,'text_color' : '#fff' }
            ]
        },
        {
            'name' : 'who' , 
            'field' : 'who_region' ,
            'groups' : [
                { 'id' : 'AFRO' , 'short_label' : 'AFRO' , 'label' : 'WHO Africa (AFRO)' , 'country' : 991 , 'color' : '#d9343f' ,'text_color' : '#fff'} , 
                { 'id' : 'PAHO' , 'short_label' : 'PAHO' ,'label' : 'WHO Americas (PAHO)' , 'country' : 992 , 'color' : '#e6b31c' } , 
                { 'id' : 'EMRO' , 'short_label' : 'EMRO' ,'label' : 'WHO East Mediterranean (EMRO)', 'country' : 993 , 'color' : '#0d890f' ,'text_color' : '#fff'} ,
                { 'id' : 'EURO' , 'short_label' : 'EURO' ,'label' : 'WHO Europe (EURO)' , 'country' : 994 , 'color' : '#14a9e7'} ,
                { 'id' : 'SEARO' , 'short_label' : 'SEARO' ,'label' : 'WHO South-East Asia (SEARO)' , 'country' : 995 , 'color' : '#21d998'} ,
                { 'id' : 'WPRO' , 'short_label' : 'WPRO' ,'label' : 'WHO Western Pacific (WPRO)' , 'country' : 996 , 'color' : '#4500b5' ,'text_color' : '#fff'} 
            ]
        },
        {
            'name' : 'income' ,
            'field' : 'income' , 
            'groups' : [
                { 'id' : 'LOW' , 'label' : 'Low Income' , 'country' : 990 , 'color' : '#0068e8' } , 
                { 'id' : 'UPPER_MIDDLE' , 'label' : 'Upper Middle Income' , 'country' : 988 , 'color' : '#cacc64' } , 
                { 'id' : 'LOWER_MIDDLE' , 'label' : 'Lower Middle Income', 'country' : 989 , 'color' : '#659c57' } ,
                { 'id' : 'HIGH' , 'label' : 'High Income' , 'country' : 987 , 'color' : '#bf226e'} 
            ]
        },
        {
            'name' : 'hub' ,
            'field' : 'hub' , 
            'groups' :  [
                { 'id' : 'AFCRN' , 'code' : 'A' , 'label' : 'Sub-Saharan Africa Hub', 'color' : '#71C8E3' , 'country' : 971 , 'sort' : 1} , 
                { 'id' : 'CARIB' , 'code' : 'C' , 'label' : 'Caribbean Hub', 'color' : '#b21c01' , 'country' : 972 , 'sort' : 2} , 
                { 'id' : 'IZMIR' , 'code' : 'I' ,'label' : 'Northern Africa, Central and Western Asia Hub', 'color' : '#724a98' , 'country' : 975 , 'sort' : 3} ,
                { 'id' : 'LA' , 'code' : 'L' ,'label' : 'Latin America Hub', 'color' : '#e0c61f' , 'country' : 973 , 'sort' : 4} ,
                { 'id' : 'MUMB' , 'code' : 'M' ,'label' : 'South East and South-Eastern Asia Hub', 'color' : '#2eaf81' , 'country' : 974 , 'sort' : 5} ,
                { 'id' : 'PI' , 'code' : 'P' ,'label' : 'Pacific Islands Hub', 'color' : '#ff6600' , 'country' : 976 , 'sort' : 6} 
            ]
        },
        {
            'name' : 'iarc_27' ,
            'field' : 'iarc_27' , 
            'groups' : [
                {
                    "id": 36,
                    "label": "Australia",
                    "country": 36
                },
                {
                    "id": 40,
                    "label": "Austria",
                    "country": 40
                },
                {
                    "id": 56,
                    "label": "Belgium",
                    "country": 56
                },
                {
                    "id": 76,
                    "label": "Brazil",
                    "country": 76
                },
                {
                    "id": 124,
                    "label": "Canada",
                    "country": 124
                },
                {
                    "id": 160,
                    "label": "China",
                    "country": 160
                },
                {
                    "id": 208,
                    "label": "Denmark",
                    "country": 208
                },
                {
                    "id": 246,
                    "label": "Finland",
                    "country": 246
                },
                {
                    "id": 250,
                    "label": "France (metropolitan)",
                    "country": 250
                },
                {
                    "id": 276,
                    "label": "Germany",
                    "country": 276
                },
                {
                    "id": 348,
                    "label": "Hungary",
                    "country": 348
                },
                {
                    "id": 356,
                    "label": "India",
                    "country": 356
                },
                {
                    "id": 364,
                    "label": "Iran, Islamic Republic of",
                    "country": 364
                },
                {
                    "id": 372,
                    "label": "Ireland",
                    "country": 372
                },
                {
                    "id": 380,
                    "label": "Italy",
                    "country": 380
                },
                {
                    "id": 392,
                    "label": "Japan",
                    "country": 392
                },
                {
                    "id": 410,
                    "label": "Korea, Republic of",
                    "country": 410
                },
                {
                    "id": 504,
                    "label": "Morocco",
                    "country": 504
                },
                {
                    "id": 528,
                    "label": "The Netherlands",
                    "country": 528
                },
                {
                    "id": 578,
                    "label": "Norway",
                    "country": 578
                },
                {
                    "id": 634,
                    "label": "Qatar",
                    "country": 634
                },
                {
                    "id": 643,
                    "label": "Russian Federation",
                    "country": 643
                },
                {
                    "id": 724,
                    "label": "Spain",
                    "country": 724
                },
                {
                    "id": 752,
                    "label": "Sweden",
                    "country": 752
                },
                {
                    "id": 756,
                    "label": "Switzerland",
                    "country": 756
                },
                {
                    "id": 826,
                    "label": "United Kingdom",
                    "country": 826
                },
                {
                    "id": 840,
                    "label": "United States of America",
                    "country": 840
                }
            ]
        },
        {
            'name' : 'other' ,
            'field' : 'other' , 
            'groups' : [
                { 'id' : '940' , 'label' : 'European Union (27)' , 'country' : 940 , 'color' : '#0068e8' } , 
                { 'id' : '963' , 'label' : 'Sub-saharan Africa' , 'country' : 963 , 'color' : '#cacc64' } 
            ]
        }
    ]
  }